// extracted by mini-css-extract-plugin
export default {"btn":"addButton_btn__OqKij","btn__plus":"addButton_btn__plus__LJJID"};